"use strict";

/**
 * @classdesc
 * Rasterlayer
 *
 * @class
 * @extends gc.gis.layer.GCLayer
 * @memberof gc.gis.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Optionen (siehe auch Optionen in {@link gc.gis.layer.GCLayer})
 * @param {string[]} [options.availableStyles=[]] Verfügbare Styles (statische Eigenschaft)
 * @param {string[]} [options.availableInfoFormats=[]] Verfügbare Formate für GetFeatureInfo-Abfragen (statische Eigenschaft)
 * @param {number} [options.drawOrder=0] Zeichenreihenfolge (statische Eigenschaft)
 * @param {boolean} [options.showLegend=true] Legende anzeigen? (statische Eigenschaft)
 * @param {boolean} [options.cached=false] Ist der Layer gecached und damit separat zu laden? (statische Eigenschaft)
 * @param {string} options.infoFormat Bevorzugtes Format für GetFeatureInfo-Abfragen (dynamische Eigenschaft)
 * @param {boolean} options.tiled Layer gekachelt laden? (dynamische Eigenschaft)
 * @param {string} options.style Zu verwendender Style (dynamische Eigenschaft)
 * @see {@link gc.gis.layer.GCLayer}
 */
gc.gis.layer.GCRasterLayer = function( options )
{
	gc.gis.layer.GCLayer.call( this, options );

    this._setConfig('styles', options.availableStyles || []);
    this._setConfig('availableInfoFormats', options.availableInfoFormats || []);
    this._setConfig('drawOrder', options.drawOrder || 0);
    this._setConfig('showLegend', gc.gis.GCUtil.parseBool(options.showLegend, true));
    this._setConfig('cached', gc.gis.GCUtil.parseBool(options.cached, false));
    this._setState('infoFormat', options.infoFormat);
    this._setState('tiled', gc.gis.GCUtil.parseBool(options.tiled, false));
    this._setState('style', options.style);
};
gc.gis.layer.GCRasterLayer.prototype = Object.create( gc.gis.layer.GCLayer.prototype );

/**
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCRasterLayer.prototype.isCached = function()
{
	return this.getConfig('cached');
};

/**
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCRasterLayer.prototype.isTiled = function()
{
	return this._getState('tiled');
};

/**
 * @public
 * @method
 * @return {string} Name des WMS-Styles
 */
gc.gis.layer.GCRasterLayer.prototype.getStyle = function()
{
	return this._getState('style');
};

/**
 * @public
 * @method
 * @return {string[]}
 */
gc.gis.layer.GCRasterLayer.prototype.getAvailableInfoFormats = function()
{
	return this.getConfig('availableInfoFormats');
};

/**
 * @public
 * @method
 * @return {string}
 */
gc.gis.layer.GCRasterLayer.prototype.getInfoFormat = function()
{
	return this._getState('infoFormat');
};

/**
 * @public
 * @method
 * @param {string} format
 */
gc.gis.layer.GCRasterLayer.prototype.setInfoFormat = function( format )
{
	this._setState('infoFormat', format );
};

/**
 * @override
 * @inheritDoc
 */
gc.gis.layer.GCRasterLayer.prototype.isQueryable = function()
{
    const formats = this.getAvailableInfoFormats();
    return formats.length > 0;
};

/**
 * @public
 * @method
 * @return {number}
 */
gc.gis.layer.GCRasterLayer.prototype.getDrawOrder = function()
{
	return this.getConfig('drawOrder');
};

/**
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCRasterLayer.prototype.getShowLegend = function()
{
	return this.getConfig('showLegend');
};

/**
 * Prüft, ob der GUI beim Laden des Layers gesperrt werden soll.
 *
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.layer.GCRasterLayer.prototype.loadModal = function () {
    // Rasterlayer, die getiled geladen und nicht gruppiert werden dürfen (cache=true), blockieren die Oberfläche
    // nicht. (Ggf. ist die Einführung eines separaten Flags z.B loadModal zukünftig am Layer dafür notwendig.)
    return !(this.isTiled() && this.isCached());
};